import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ['prevButton', 'nextButton', 'items', 'buttonContainer'];

  connect() {
    this.updateButtons();
  }

  updateButtons() {
    const items = this.itemsTargets;

    if (items.length == 1)
      return;

    const activeIndex = items.findIndex((item) => item.classList.contains('active'));

    if (activeIndex === 0) {
      this.prevButtonTarget.classList.add('hidden');
    } else {
      this.prevButtonTarget.classList.remove('hidden');
    }

    if (activeIndex === items.length - 1) {
      this.nextButtonTarget.classList.add('hidden');
    } else {
      this.nextButtonTarget.classList.remove('hidden');
    }

    const isPrevVisible = !this.prevButtonTarget.classList.contains('hidden');
    const isNextVisible = !this.nextButtonTarget.classList.contains('hidden');

    if (isPrevVisible && isNextVisible) {
      this.buttonContainerTarget.classList.remove('justify-start', 'justify-end');
      this.buttonContainerTarget.classList.add('justify-between');
    } else if (isPrevVisible) {
      this.buttonContainerTarget.classList.remove('justify-between', 'justify-end');
      this.buttonContainerTarget.classList.add('justify-start');
    } else if (isNextVisible) {
      this.buttonContainerTarget.classList.remove('justify-between', 'justify-start');
      this.buttonContainerTarget.classList.add('justify-end');
    }
  }

  previous() {
    const items = this.itemsTargets;
    const activeIndex = items.findIndex((item) => item.classList.contains('active'));

    if (activeIndex > 0) {
      items[activeIndex].classList.remove('active');
      items[activeIndex - 1].classList.add('active');
      this.updateButtons();
    }
  }

  next() {
    const items = this.itemsTargets;
    const activeIndex = items.findIndex((item) => item.classList.contains("active"));

    if (activeIndex < items.length - 1) {
      items[activeIndex].classList.remove("active");
      items[activeIndex + 1].classList.add("active");
      this.updateButtons();
    }
  }
}
